 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		19: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		19: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"styles","2":"0ab67a3e6e153e7fbe5626e01d709d17c926265b","3":"f519ea06ced0b69c3a36ce7265052c462e53586a","4":"e2e1109a6213cdd8f580d6120a016450a43f7379","5":"a748f2e97117543d0e55fdcd171bdd42406d6daa","6":"a73e2e13249af2af207a1e48188cefb067dd87c2","7":"5ed64baea96c5e28e37e0a3396666fd35d096cd9","8":"b9390e6aecf2b5cb0f159fd5482310f090c8dfbf","9":"ea88be26","10":"7c5ead21e5908f6f25786a511bc70f58e243c1f8","11":"dc594759cb49af661456344cd3ccafd180f5a3e7","12":"965e77cbf5d7fd4e7e7e3c8afb64a368e6ced68f","13":"1fe38f8b2c6ac76250641bb343cb2acacb47860c","14":"7723483330c604f709063740994781512be65870","15":"e524430a37e415652ead067f4cef2d0738f8ffd0","16":"a1fda6617e25b9837fea1bf683b2d8ad818416f8","17":"f1fbbf37dbc369d2d0a08906033a0959ac810c1a","18":"fa9fe86e28d2e8d761e1503e2765752a859afffd","21":"component---src-pages-404-js","22":"component---src-pages-about-index-js","23":"component---src-pages-contact-js","24":"component---src-pages-index-js","25":"component---src-pages-notification-js","26":"component---src-pages-portfolio-index-js","27":"component---src-pages-portfolio-map-js","28":"component---src-pages-privacy-js","29":"component---src-pages-terms-js","30":"component---src-pages-under-construction-js","31":"component---src-pages-unsubscribe-js","32":"component---src-templates-project-briefing-js","33":"component---src-templates-project-gallery-js","34":"component---src-templates-project-location-js","35":"component---src-templates-project-progress-js","36":"component---src-templates-project-snapshot-js","37":"component---src-templates-project-timeline-js","38":"component---src-templates-project-timeline-post-js","39":"component---src-templates-project-vision-js","40":"e7ff715b","43":"reactPlayerDailyMotion","44":"reactPlayerFacebook","45":"reactPlayerFilePlayer","46":"reactPlayerKaltura","47":"reactPlayerMixcloud","48":"reactPlayerMux","49":"reactPlayerPreview","50":"reactPlayerSoundCloud","51":"reactPlayerStreamable","52":"reactPlayerTwitch","53":"reactPlayerVidyard","54":"reactPlayerVimeo","55":"reactPlayerWistia","56":"reactPlayerYouTube"}[chunkId]||chunkId) + "-" + {"0":"f89071c21ef82ac88d6e","1":"e9d24b1846c7d6eb9685","2":"70883c24199977fb1bb3","3":"4b41f741d30a1ea50045","4":"0d9644ada149ae6d071a","5":"0a14feed95f8e72de50d","6":"fdb997cef47177760f16","7":"cee61fb8496e9dd2ae05","8":"e4fd1030ad5ea6dda021","9":"fed20b5780f776d8081b","10":"3f3e165bfbc0d8889690","11":"c6da46a15a1d5a76c378","12":"b15ab35a7bd6a23a5350","13":"7fd45f88f863b4669c62","14":"ee33c951619297061bb9","15":"abc979a84a4493bd7e44","16":"ceeb58251875f3c16c5c","17":"5e413a2d38067a5779a0","18":"3b5d8ee379c4f89eef33","21":"20ed92222504f48113d2","22":"737293d0168689e5df49","23":"f41b2688d7d16555377c","24":"546e39527c373d91bc5d","25":"38a5074233d16c8ff9a8","26":"34386d3d8f4b92527358","27":"a9d64626707271968bf1","28":"a0a810f6806d9c6f3a8a","29":"75b34ac225b2d1af5edd","30":"4d1f231adffd065a2f73","31":"4a286dbe5f9c56907a01","32":"6861fe3cf56c06f5336d","33":"d4ed0ba41a45befd783f","34":"a843fcf95acf41d0b4ca","35":"84ac676a4fb44e0079d5","36":"6060ca1ce96d91847c01","37":"b7a080d2a04ccce68287","38":"a5a1457b335d78ddd05d","39":"d41e7ccc70d48694214d","40":"19dd55f639a41400c85d","43":"3ec528f6bb6bb789cfe0","44":"02903bde6dc1c20b4f58","45":"cf3119d8e1a2f715bb06","46":"5a05ca8f3194863276ed","47":"bc0ef4789b0c485a0d1e","48":"44a564af06b342ad120f","49":"ee7a1b7f014d4b1258f4","50":"f5ccaf30162fbd3385cd","51":"d04d8cd76ac9fc23e5a8","52":"d8bde570242007f8794e","53":"4c5ba0b77e565f3d6387","54":"89010e9036ebb42dbfc6","55":"32d59be57f081223d0ce","56":"a27c0da8321acd3a4a90","57":"e6cbb1db5ff53ba11ec8"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"styles","2":"0ab67a3e6e153e7fbe5626e01d709d17c926265b","3":"f519ea06ced0b69c3a36ce7265052c462e53586a","4":"e2e1109a6213cdd8f580d6120a016450a43f7379","5":"a748f2e97117543d0e55fdcd171bdd42406d6daa","6":"a73e2e13249af2af207a1e48188cefb067dd87c2","7":"5ed64baea96c5e28e37e0a3396666fd35d096cd9","8":"b9390e6aecf2b5cb0f159fd5482310f090c8dfbf","9":"ea88be26","10":"7c5ead21e5908f6f25786a511bc70f58e243c1f8","11":"dc594759cb49af661456344cd3ccafd180f5a3e7","12":"965e77cbf5d7fd4e7e7e3c8afb64a368e6ced68f","13":"1fe38f8b2c6ac76250641bb343cb2acacb47860c","14":"7723483330c604f709063740994781512be65870","15":"e524430a37e415652ead067f4cef2d0738f8ffd0","16":"a1fda6617e25b9837fea1bf683b2d8ad818416f8","17":"f1fbbf37dbc369d2d0a08906033a0959ac810c1a","18":"fa9fe86e28d2e8d761e1503e2765752a859afffd","21":"component---src-pages-404-js","22":"component---src-pages-about-index-js","23":"component---src-pages-contact-js","24":"component---src-pages-index-js","25":"component---src-pages-notification-js","26":"component---src-pages-portfolio-index-js","27":"component---src-pages-portfolio-map-js","28":"component---src-pages-privacy-js","29":"component---src-pages-terms-js","30":"component---src-pages-under-construction-js","31":"component---src-pages-unsubscribe-js","32":"component---src-templates-project-briefing-js","33":"component---src-templates-project-gallery-js","34":"component---src-templates-project-location-js","35":"component---src-templates-project-progress-js","36":"component---src-templates-project-snapshot-js","37":"component---src-templates-project-timeline-js","38":"component---src-templates-project-timeline-post-js","39":"component---src-templates-project-vision-js","40":"e7ff715b","43":"reactPlayerDailyMotion","44":"reactPlayerFacebook","45":"reactPlayerFilePlayer","46":"reactPlayerKaltura","47":"reactPlayerMixcloud","48":"reactPlayerMux","49":"reactPlayerPreview","50":"reactPlayerSoundCloud","51":"reactPlayerStreamable","52":"reactPlayerTwitch","53":"reactPlayerVidyard","54":"reactPlayerVimeo","55":"reactPlayerWistia","56":"reactPlayerYouTube"}[chunkId]||chunkId) + "." + {"0":"31d6cfe0d16ae931b73c","1":"f8db44c44944f0992a24","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c","32":"31d6cfe0d16ae931b73c","33":"31d6cfe0d16ae931b73c","34":"31d6cfe0d16ae931b73c","35":"31d6cfe0d16ae931b73c","36":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","43":"31d6cfe0d16ae931b73c","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"31d6cfe0d16ae931b73c","47":"31d6cfe0d16ae931b73c","48":"31d6cfe0d16ae931b73c","49":"31d6cfe0d16ae931b73c","50":"31d6cfe0d16ae931b73c","51":"31d6cfe0d16ae931b73c","52":"31d6cfe0d16ae931b73c","53":"31d6cfe0d16ae931b73c","54":"31d6cfe0d16ae931b73c","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
